// @flow strict

import addEntry from '../addEntry'
import { guid } from '../utils'
import type {
  MessageBusCallback,
  MessageBusContext,
  MessageBusEventBody,
  MessageBusEventDetail, MessageBusEventListener,
  MessageBusRoutingKey
} from './types'
import { doRoutingKeysMatch } from './MessageRouting'

class GeniusSportsMessageBus {
    static EventType = 'geniussportsmessagebus';
    _listeners_: { string?: Array<MessageBusEventListener> };
    constructor () {
      this._listeners_ = {}
      if (typeof window !== 'undefined') {
        window.addEventListener(GeniusSportsMessageBus.EventType, (event: Event) => this._handleEvent_(event))
      }
    }

    dispatchEvent (type: string, body: ?MessageBusEventBody, routingKey: MessageBusRoutingKey = {}, correlationId: string = guid()): string {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(this._createCustomEvent_(type, body, routingKey, correlationId))
      }
      return correlationId
    }

    _createCustomEvent_ (type: string, body: ?MessageBusEventBody, routingKey: MessageBusRoutingKey, correlationId: string): CustomEvent {
      return new CustomEvent(GeniusSportsMessageBus.EventType, {
        detail: {
          'correlationId': correlationId,
          'routingKey': routingKey,
          'type': type,
          'body': body
        }
      })
    }

    addEventListener (type: string, callback: MessageBusCallback, context: MessageBusContext = {}, routingKey: MessageBusRoutingKey = {}): void {
      let listenersForType: Array<MessageBusEventListener> = this._listeners_[type]
      if (!listenersForType) {
        this._listeners_[type] = listenersForType = []
      }
      listenersForType.push({ callback, context, routingKey })
    }

    removeEventListener (type: string, callback: MessageBusCallback): void {
      const listenersForType: Array<MessageBusEventListener> = this._listeners_[type]
      if (listenersForType) {
        this._listeners_[type] = listenersForType.filter((listener: MessageBusEventListener) => listener.callback !== callback)
      }
    }
    listenOnce (type: string, callback: MessageBusCallback, context: MessageBusContext, routingKey?: MessageBusRoutingKey) {
      const wrappedCallback: MessageBusCallback = (detail: MessageBusEventDetail, event: CustomEvent): void => {
        callback.call(context, detail, event)
        this.removeEventListener(type, wrappedCallback)
      }
      this.addEventListener(type, wrappedCallback, this, routingKey)
    }

    _handleEvent_ (event: Event): void {
      if (event instanceof CustomEvent) {
        let detail: MessageBusEventDetail = event.detail
        if (!detail.routingKey) {
          detail.routingKey = {}
        }
        const listeners: ?Array<MessageBusEventListener> = this._listeners_[detail.type]
        if (listeners instanceof Array) {
          listeners.forEach(({ callback, context, routingKey }) => {
            // only dispatch updates if detail.routingKey matches listener's routing key or listener has no routing key
            const defaultValueRoutingKey: MessageBusRoutingKey = (routingKey) || {}

            if (doRoutingKeysMatch(defaultValueRoutingKey, detail.routingKey)) {
              try {
                callback(detail, event)
              } catch (e) {
                // needs logger
              }
            }
          })
        }
      }
    }
}

export default addEntry('GeniusSportsMessageBus', GeniusSportsMessageBus)



// WEBPACK FOOTER //
// ./src/main/javascript/genius-sports-message-bus/index.js